import { useSelector } from 'react-redux'
import { selectAllBranches } from '@user/store/branches/slice'
import { useMemo } from 'react'

export const useBranchSearch = (query?: string) => {
  const branches = useSelector(selectAllBranches)

  const filteredBranches = useMemo(() => {
    return branches.filter((branch) => {
      if (!query || query == '') return true

      const filter = query.toLowerCase()
      const name = branch.name.toLowerCase()
      return name.includes(filter)
    })
  }, [branches, query])

  return filteredBranches
}
